import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import GoogleButton from "@/components/GoogleButton";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user !== false) navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.access_token) localStorage.setItem("access_token", data.access_token);
      setUser(data);
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Errore di accesso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 grain">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex justify-center mb-8" data-testid="login-brand-link">
          <img src="/brand/logo-black.png" alt="ourweddly" className="h-12 w-auto" />
        </Link>
        <p className="eyebrow mb-3 text-center">Area organizzatori</p>
        <h1 className="font-wed text-4xl mb-8 text-center">Bentornati</h1>
        <div className="bg-white border rounded-3xl p-8 space-y-5" style={{ borderColor: "#e3ddd2" }}>
          <GoogleButton />
          <div className="flex items-center gap-4">
            <div className="h-px flex-1 bg-[#e3ddd2]" />
            <span className="text-xs text-neutral-400 uppercase tracking-wider">oppure</span>
            <div className="h-px flex-1 bg-[#e3ddd2]" />
          </div>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="label-wed">Email</label>
              <input className="input-wed" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.it" data-testid="login-email-input" />
            </div>
            <div>
              <div className="flex items-center justify-between">
                <label className="label-wed">Password</label>
                <Link to="/forgot-password" className="text-xs mb-1.5" style={{ color: "var(--wed-primary)" }} data-testid="login-forgot-password-link">Password dimenticata?</Link>
              </div>
              <input className="input-wed" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password-input" />
            </div>
            <button type="submit" className="btn-wed w-full" disabled={loading} data-testid="login-submit-button">
              {loading ? "Accesso…" : "Accedi"}
            </button>
          </form>
        </div>
        <p className="text-center text-sm text-neutral-500 mt-6">
          Non hai un account?{" "}
          <Link to="/register" className="font-medium" style={{ color: "var(--wed-primary)" }} data-testid="login-to-register-link">Registrati</Link>
        </p>
      </div>
    </div>
  );
}
